import { TEMPLATE_INTRO_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { ITemplateIntro } from "../../shared/interfaces/templateIntro/ITemplateIntro";

export const TemplateIntroService = {
  get: (pagination: IPagination): Promise<IBaseModel<ITemplateIntro[]>> =>
    requests.get(TEMPLATE_INTRO_URL, pagination),
  getSingle: (id: number): Promise<ITemplateIntro> =>
    requests.get(`${TEMPLATE_INTRO_URL}/${id}`),
  create: (params: ITemplateIntro) => requests.post(TEMPLATE_INTRO_URL, params),
  update: (params: ITemplateIntro, id: number) =>
    requests.put(`${TEMPLATE_INTRO_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${TEMPLATE_INTRO_URL}/${id}`),
};
